import { spacing } from '../constants/spacing.js';

var contentSwitcherThemeNative = {
  color: 'primary',
  active: {
    textColor: 'background.primary',
    backgroundColor: 'primary'
  },
  button: {
    borderRadius: 'borders.radius'
  },
  background: 'background.secondary',
  separator: 'border.inactive',
  disabled: {
    font: 'label.disabled'
  },
  paddings: {
    "default": spacing.xxs,
    small: spacing.xxxs,
    afterIcon: 8
  },
  font: {
    size: {
      s: 16,
      m: 18,
      l: 18
    }
  },
  height: {
    s: 40,
    m: 48,
    l: 56
  }
};
var contentSwitcherThemeWeb = {
  color: 'primary',
  active: {
    background: 'primary',
    textColor: 'background.primary'
  },
  background: 'background.secondary',
  separator: 'border.inactive',
  disabled: {
    font: 'label.disabled'
  },
  font: {
    size: {
      s: 16,
      m: 18,
      l: 18
    }
  },
  height: {
    s: 40,
    m: 48,
    l: 56
  },
  /**
   * Button horizontal paddings
   */
  paddings: {
    desktop: spacing.xxs,
    mobile: spacing.xxxs
  }
};

export { contentSwitcherThemeNative, contentSwitcherThemeWeb };
